<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? `1px dashed rgba(58,96,255,1)`
          : '1px solid #dcdde0',
    }"
  >
    <div class="question-type">多项填空</div>
    <div class="title-view">
      <span style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span
        >{{ `${index + 1}、` }}
        <span style="color: #4c4a56">
          {{ `${dataObj.caseProblem}` }}
          <span
            style="
              position: relative;
              top: -2px;
              padding: 0 15px;
              line-height: 20px;
              background: rgba(58, 96, 255, 0.09);
              border: 1px solid rgba(58, 96, 255, 0.4);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              text-align: center;
              color: #3a60ff;
              display: inline-block;
              margin-left: 10px;
            "
          >
            {{ dataObj.questionScore ? dataObj.questionScore : "0" }}分</span
          >
        </span>
      </span>
    </div>
    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 20px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>
    <div v-for="(item, idx) in list" :key="idx">
      <div v-if="showAnswer" style="margin-top: 20px">
        <span
          v-if="item.text !== ''"
          style="
            word-break: break-all;
            font-size: 14px;
            color: #2b2f36;
            font-weight: 400;
          "
        >
          {{ item.text }}
        </span>
        <div
          v-if="item.color === '1'"
          class="choose-css"
          style="
            border: 1px solid rgba(74, 115, 247, 0.5);
            background: rgba(74, 115, 247, 0.1);
          "
        >
          <span
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(58, 96, 255, 1);
            "
          >
            {{ item.context }}
          </span>
          <div style="display: flex; align-items: center">
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747725751245.svg"
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
        <div
          v-if="item.color === '2'"
          class="choose-css"
          style="
            border: 1px solid rgba(247, 59, 66, 0.5);
            background: rgba(247, 59, 66, 0.1);
          "
        >
          <span
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(247, 59, 66, 1);
            "
          >
            {{ item.context }}
          </span>
          <div style="display: flex; align-items: center">
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747885842739.svg"
              style="width: 15px; height: 15px"
            />
          </div>
        </div>
      </div>
      <div v-else style="margin-top: 10px">
        <span
          v-if="item.text !== ''"
          style="
            word-break: break-all;
            font-size: 14px;
            color: #2b2f36;
            font-weight: 400;
            word-wrap: break-word;
            word-break: break-all;
            width: 100%;
            text-align: left;
            display: block;
          "
        >
          {{ item.text }}
        </span>
        <div
          :style="{
            border:
              isFocus === idx
                ? `1px solid rgba(${themeColor.r},${themeColor.g},${themeColor.b})`
                : '1px solid #EDEDED',
          }"
          class="textarea-view textarea-view-new"
        >
          <el-input
            v-if="dataObj.status === 3 || dataObj.status === 4"
            type="textarea"
            v-model="item.context"
            placeholder="请输入"
            :autosize="{ minRows: 1 }"
            @focus="handleInputFocus(idx)"
            @blur="handleInputBlur()"
            @input="handleInputChange(idx)"
            :disabled="
              dataObj.status !== 4 || showState === 10 || showState === 7
            "
          ></el-input>
          <span v-else class="textarea-placeholder">请输入</span>

          <div class="question-images">
            <div
              class="question-images-box"
              @click.stop="showBigImage(imgItem, item)"
              v-for="(imgItem, imgIndex) in item.img_path"
              :key="imgIndex"
              style="margin-top: 10px; position: relative"
            >
              <img :src="imgItem" class="thumbnail-image" />
              <div class="fangda-box">查看图片</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fangda-popup" v-if="fangdaShow" @click="fangdaClose">
      <div class="popup-content" @click.stop>
        <img
          src="@/assets/images/guanbi.png"
          class="popup-guanbi"
          @click="fangdaClose"
        />
        <div class="popup-scroll">
          <div>{{ fangdaTitle }}</div>
          <img :src="fangdaImgUrl" style="width: 100%" />
        </div>
      </div>
    </div>
    <div v-if="showState === 10">
      <div
        v-if="dataObj.ifRight"
        style="display: flex; align-items: center; margin-top: 10px"
      >
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335507420.svg"
          style="width: 32px; height: 32px"
        />
        <span class="correct-text">回答正确 +{{ dataObj.score }}分</span>
      </div>
      <div v-else style="display: flex; align-items: center; margin-top: 10px">
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335577224.svg"
          style="width: 32px; height: 32px"
        />
        <span class="error-text" style="font-size: 30px; font-weight: 500"
          >答错了 {{ dataObj.score > 0 ? `+${dataObj.score}分` : "" }}</span
        >
      </div>
      <div v-if="!dataObj.ifRight" style="margin-top: 10px">
        <span
          style="
            font-size: 30px;
            font-weight: 500;
            text-align: left;
            color: #00c755;
          "
          >正确答案</span
        >
        <div
          style="
            width: 100%;
            padding: 13px;
            box-sizing: border-box;
            background: #f7f7f7;
            border: 1px solid #ededed;
            border-radius: 3px;
            margin-top: 8px;
          "
        >
          {{ dataObj.chooseAnswer }}
        </div>
      </div>
      <div class="explanation-section" style="margin-top: 10px">
        <span class="section-title" style="font-size: 15px; font-weight: 500"
          >答案解析</span
        >
        <div class="textarea-view">{{ dataObj.analysis || "暂无内容" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamPreviewMBQ",
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    showAnswer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocus: -1,
      list: [],
      images: [],
      themeColor: {
        r: 58,
        g: 96,
        b: 255,
      },
      index: 0,
      showState: 0,
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue && newValue.data) {
          this.dataObj = newValue.data;
          this.index = newValue.index;
          this.showState = newValue.state;
          this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
          this.list = JSON.parse(
            newValue.data.chooseList || '{"list":[]}',
          ).list;

          if (newValue.theme !== null) {
            this.themeColor = {
              r: newValue.theme.themeColor.r,
              g: newValue.theme.themeColor.g,
              b: newValue.theme.themeColor.b,
            };
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleInputFocus(index) {
      this.isFocus = index;
    },
    handleInputBlur() {
      this.isFocus = -1;
    },
    handleInputChange(index) {
      const answerObj = {
        question_id: this.dataObj.data.id,
        type: this.dataObj.data.type,
        if_hide: this.dataObj.data.if_hide,
        answer: this.list.map((item) => ({
          id: item.id,
          context: item.context,
        })),
      };

      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          answer: answerObj,
          data: {
            ...this.dataObj.data,
            chooseList: JSON.stringify({ list: this.list }),
          },
        }),
      );
    },
    showBigImage(img, option) {
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text;
    },
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./exam-preview-common.scss";

.textarea-view {
  min-height: 40px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamPreview/ExamPreviewMBQ.vue